import ReactPaginate from 'react-paginate';
import { PaginationCover } from '../BabyNameFinder/Pagination.styled';

export default function HindiParentingPagination({
  limit,
  fetchData,
  count,
  pageValue,
  lang,
}) {
  const pageCount = Math.ceil(count / limit) - 1;

  const onClickHandler = (event) => {
    const page = event.nextSelectedPage + 1;
    fetchData(page);
  };

  return (
    <div>
      {pageCount > 1 ? (
        <PaginationCover>
          <ReactPaginate
            breakLabel="..."
            nextLabel="▶❙"
            onClick={onClickHandler}
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            pageCount={pageCount}
            previousLabel="❙◀"
            renderOnZeroPageCount={null}
            className="pagination"
            pageClassName="pageClassName"
            initialPage={pageValue ? JSON.parse(pageValue) - 1 : 0}
            hrefBuilder={(page) => `/${lang}/parenting?${lang}page=${page}`}
            hrefAllControls={true}
            activeLinkClassName={'activeClass'}
          />
        </PaginationCover>
      ) : null}
    </div>
  );
}
